module.exports = __webpack_public_path__ + "static/media/accomodation.8038ec46.jpeg";